import React from 'react'
import _ from 'lodash'
import { Modal, Tabs } from 'antd'
import WrappedUpdateBranch from '../UpdateBranch'


const UpdateBranchForm = (props) => {
  const { visible, onOk, onCancel, heroId , branch } = props

  return (
    <Modal
      destroyOnClose={true}
      title="Update Branch"
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <Tabs type="card" defaultActiveKey="1">
        <Tabs.TabPane tab="Update Branch Available" key="1">
          <WrappedUpdateBranch
            onOk={onOk}
            onCancel={onCancel}
            heroId={heroId}
            branch={branch}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}

export default UpdateBranchForm
